import(/* webpackMode: "eager" */ "/home/buyme-stg/htdocs/stg.buyme.lk/src/app/error.tsx");
